import { Link, type ErrorComponentProps } from "@tanstack/react-router";

import { Button } from "@/components/ui/button";

/** Shared centered shell for the route-level not-found / error states. */
function CenteredCard({ children }: { children: React.ReactNode }) {
  return (
    <main className="flex min-h-screen items-center justify-center bg-background px-6 text-foreground">
      <div className="flex max-w-md flex-col items-center gap-4 text-center">
        {children}
      </div>
    </main>
  );
}

export function NotFound() {
  return (
    <CenteredCard>
      <p className="text-5xl font-semibold lowercase tracking-tight">404</p>
      <p className="text-sm text-muted-foreground">
        That page doesn't exist.
      </p>
      <Button asChild variant="outline">
        <Link to="/">Back to board</Link>
      </Button>
    </CenteredCard>
  );
}

export function RouteError({ error, reset }: ErrorComponentProps) {
  return (
    <CenteredCard>
      <p className="text-lg font-semibold">Something went wrong</p>
      <p className="text-sm text-muted-foreground">
        {error instanceof Error ? error.message : "An unexpected error occurred."}
      </p>
      <div className="flex gap-2">
        <Button variant="outline" onClick={() => reset()}>
          Try again
        </Button>
        <Button asChild>
          <Link to="/">Back to board</Link>
        </Button>
      </div>
    </CenteredCard>
  );
}
